/**
 * Created by staffanrantzow on 12/10/16.
 */

import React, { PropTypes } from 'react';
import { InvoiceService, EmploymentCertificateService, Utils } from 'frilans-finans';
import { Spinner, GeneralError, SpinnerButton } from 'components';
import { history } from 'store';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { connect } from 'react-redux';

export class EmployerCertificate extends React.Component {

  static propTypes = {
    params: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      invoice: null,
      user: null,
      fetching: true,
      fetchError: false,
      posting: false,
      postError: false,
      postSuccess: false
    };

    this.fetchInvoice();

    this.orderEmployerCerts = this.orderEmployerCerts.bind(this);
  }

  fetchInvoice () {
    InvoiceService.getById(this.props.params.id)
      .then((response) => {
        this.setState({
          fetchError: false,
          fetching: false,
          invoice: response
        });
      })
      .catch(() => {
        this.setState({
          fetchError: true,
          fetching: false
        });
      });
  }

  orderEmployerCerts () {
    EmploymentCertificateService.post([parseInt(this.state.invoice.id)])
      .then(this.handleSuccess.bind(this))
      .catch(this.handleError.bind(this));

    this.setState({
      posting: true,
      postError: false,
      postSuccess: false
    });
  }

  handleSuccess () {
    this.setState({
      posting: false,
      postSuccess: true,
      postError: false
    });
  }

  handleError () {
    this.setState({
      posting: false,
      postError: true,
      postSuccess: false
    });
  }

  renderLoader () {
    return (
      <div className='loader-wrapper'>
        <Spinner />
      </div>
    );
  }

  renderPostError () {
    if (this.state.postError) {
      return (<GeneralError/>);
    }
  }

  renderCertificate () {
    let i = this.state.invoice;
    let salaryGross = 0;
    for (let userSalary of i.salaries) {
    // TODO: FIND REASON WHY REGULAR INVOICES GET CREDITED
      if (userSalary.userId === parseInt(this.props.user.id) &&
      userSalary.typeId === 1 && [1, 2, 3, 4].includes(userSalary.categoryId)) {
        salaryGross += userSalary.grossAmount;
      }
    }

    return (
      <div>
        <table className='slim-table'>
          <tbody>
            <tr>
              <td><Translate content='CUSTOMER'/></td>
              <td>{i.customer.name}</td>
            </tr>
            <tr>
              <td><Translate content='ORDER_NR'/></td>
              <td>{i.id}</td>
            </tr>
            <tr>
              <td><Translate content='CREATED'/></td>
              <td><Translate content='CREATED_DATE'
                date={Utils.formatDate(i.createdAt)} /></td>
            </tr>
            <tr>
              <td><Translate content='GROSS_SALARY'/></td>
              <td>{Math.round(salaryGross)} KR</td>
            </tr>
            <tr>
              <td><Translate content='GROSS_SALARY_H'/></td>
              <td>{Math.round(salaryGross / i.hours)} KR</td>
            </tr>
            <tr>
              <td><Translate content='INVOICE_PAY'/></td>
              <td>{Utils.formatDate(i.fullPaymentDateTime)}</td>
            </tr>
          </tbody>
        </table>

        {this.renderPostError()}

        <SpinnerButton text={proxyCounterpart('BACK')}
          loading={false} classes='btn outlined blue back-btn' callback={history.goBack}/>

        <SpinnerButton text={proxyCounterpart('ORDER_EMP_CERT')}
          loading={this.state.posting} classes='btn submit-btn' callback={this.orderEmployerCerts}/>
      </div>
    );
  }

  getContent () {
    if (this.state.fetching) {
      return (this.renderLoader());
    }
    if (this.state.fetchError) {
      return (<GeneralError />);
    }
    if (this.state.postSuccess && !this.state.posting) {
      return (<p className='info'><Translate content='EMP_CERT_SUCCESS'/></p>);
    }

    return this.renderCertificate();
  }

  render () {
    let content = this.getContent();

    return (
      <div className='employer-certificate'>
        <div className="container">
          <div className="row">
            <div className="col-sm-8">
              <h2><Translate content='EMPLOYER_CERTIFICATE'/></h2>
              {content}
            </div>
          </div>
        </div>
      </div>
    );
  }

}
function mapStateToProps (state) {
  return {
    user: state.user
  };
};

export default connect(
  mapStateToProps
)(EmployerCertificate);



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/employer-certificate/employer-certificate.js
 **/